export const globalTheme = {
    typography: {
      button: {
        textTransform: "none"
      }
    },
    palette: {
      type: "dark",
      //set default dark mode text color
      text: {
        primary: "#E2F1F1"
      },
      //backgrounds
      primary: {
        light: "#1A2429",
        main: "#C00",
        dark: "#FFFFFF",
      },
      //text/accents
      secondary: {
        light: "#2E3045",
        main: "#C00",
        dark: "#5DADA8",
        contrastText: '#2196f3'
      },
      //buttons and misc
      tertiary: {
        light: "#2E3045",
        main: "#C6B656",
        dark: "#5DADA8"
      },
      background: {
        default: '#1A2429',
        light: '#F8FFFF',
        dark: '#1A2429'
      },
      buttonBackground:{
        light: "#5DADA8",
        dark: "#5DADA8"
      },
      buttonText:{
        light: "#FFFFFF",
        dark: "#1A2429"
      },
      carouselArrow:{
        light: "#1A2429",
        dark: "#FFFFFF"
      },
      drawer: {
        light: "#F8FFFF",
        dark: "#1A2429"
      },
      mainBorder: {
        light: "#1A2429",
        dark: "#16DFD3"
      },
      heading: {
        light: "#E2F1F1",
        dark: "#26343B"
      },
      scrollBar: {
        light: "#2E3045",
        dark: "#16DFD3"
      }
      // error: will use the default color
    }
  };